module.exports = __webpack_public_path__ + "img/5a2b6cb.jpg";